<template>
  <div class="d-flex align-center column-gap-2 cursor-move">
    <app-icon icon-name="arrows" icon-weight="fal" />

    <div class="step-card">
      <span>{{ index }} {{ title }}</span>

      <app-button
        v-if="removable"
        type="icon"
        class="ml-4"
        :disabled="signatureGroupsEditionPending"
        @click="onDelete"
      >
        <app-icon icon-name="circle-xmark" icon-weight="fas" />
      </app-button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'SigningChecklistStepToOrder',
  emits: ['delete'],
  props: {
    title: {
      type: String,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('signingChecklistOrder', ['signatureGroupsEditionPending']),
  },
  methods: {
    onDelete () {
      this.$emit('delete')
    },
  },
})
</script>

<style scoped lang="scss">
.step-card {
  height: 52px;
  border: 2px solid #bdbdbd;
  border-left: 4px solid #cc453e;
  border-radius: 6px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
}
</style>
